var _jsxFileName = "/repo/packages/webassets/src/components/Header/anonymous/Desktop/components/SubMenu.js",
  _this = this;
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@sm/wds-react';
import classNames from 'classnames';
import SMHeaderContext from '../../../SMHeaderContext';
import { NavBarAnonContext } from '../NavBarAnonContext';
export var SubMenu = function SubMenu(_ref) {
  var submenuKey = _ref.submenuKey,
    title = _ref.title,
    children = _ref.children;
  var _useContext = useContext(SMHeaderContext),
    lang = _useContext.lang;
  var _useContext2 = useContext(NavBarAnonContext),
    submenuOpened = _useContext2.submenuOpened;
  var submenuClassname = classNames('sm-nav-submenu__container', "sm-nav-submenu__".concat(submenuKey.toLowerCase()), 'sm-utils--text-align-left', {
    'sm-nav-submenu--en': lang === 'en'
  }, {
    'sm-nav-submenu--de': lang === 'de'
  }, {
    'sm-nav-submenu--fr': lang === 'fr'
  }, {
    'sm-nav-submenu--locale': lang !== 'en'
  }, {
    'sm-nav-submenu--open': submenuOpened === submenuKey
  });
  return /*#__PURE__*/React.createElement("div", {
    className: submenuClassname,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }, lang !== 'en' && /*#__PURE__*/React.createElement(Typography, {
    variant: "sectionTitle",
    className: "sm-nav-submenu__title sm-utils--text-align-center sm-utils--mw-90 sm-utils--mx-auto sm-utils--text-overflow-break",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 26,
      columnNumber: 9
    }
  }, title), children);
};
export default SubMenu;
SubMenu.propTypes = {
  title: PropTypes.string.isRequired,
  submenuKey: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};
//# sourceMappingURL=SubMenu.js.map